import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
export default function NewFaq() {
  const data=[
    {
      id:"q1",
      ques:"1. ¿Qué son las Fichas?",
      ans:"Las Fichas son tu moneda en el juego que se usa para jugar partidas de póker y torneos. Puedes reclamarlas diariamente y por hora (cada 60 minutos) y también puedes obtenerlas viendo anuncios o completando tareas."
    },
    {
      id:"q2",
      ques:"2. Me quedé sin Fichas. ¿Qué hago?",
      ans:"Puedes reclamar fichas diariamente y por hora (cada 60 minutos). También puedes ganar más viendo anuncios o completando tareas de recompensa."
    },
    {
      id:"q3",
      ques:"3. ¿Qué son los Puntos de Recompensa?",
      ans:"Los Puntos de Recompensa se obtienen jugando — al clasificarte en las tablas de posiciones, terminar en posiciones de pago en torneos, o completar tareas. Puedes canjearlos en la Baazi Store por ofertas y tarjetas de regalo de las mejores marcas."
    },
    {
      id:"q4",
      ques:"4. ¿Cómo gano Puntos de Recompensa?",
      ans:"Juega partidas, sube en las tablas de posiciones, completa tareas diarias, o termina en posiciones de pago en torneos para ganar Puntos de Recompensa."
    },
    {
      id:"q5",
      ques:"5. ¿Cómo uso los Puntos de Recompensa?",
      ans:"Abre la Baazi Store en la app, elige tu oferta o cupón preferido y canjéalo usando tus Puntos de Recompensa disponibles."
    },
    {
      id:"q6",
      ques:"6. ¿Puedo canjear los Puntos de Recompensa por dinero en efectivo?",
      ans:"No. Los Puntos de Recompensa solo se pueden usar para canjear ofertas o cupones en la Baazi Store."
    },
    {
      id:"q7",
      ques:"7. Canjeé mis Puntos de Recompensa pero no recibí el artículo.",
      ans:"Por favor permite hasta 48 horas para el procesamiento. Si no lo recibes, comunícate con el Soporte con el nombre de la recompensa y la fecha de canje para obtener ayuda."
    },
    {
      id:"q8",
      ques:"8. ¿Puedo transferir Fichas o Puntos de Recompensa a otro jugador?",
      ans:"No. Tanto las Fichas como los Puntos de Recompensa no son transferibles y están vinculados únicamente a tu cuenta."
    },
    {
      id:"q9",
      ques:"9. ¿Dónde puedo ver mis saldos?",
      ans:"Puedes ver tus Fichas y Puntos de Recompensa en la sección de Cartera de la app en cualquier momento."
    },
    {
      id:"q10",
      ques:"10. Mi saldo aún no se ha actualizado. ¿Qué hago?",
      ans:"Actualiza la app o cierra sesión y vuelve a iniciar sesión. Si el problema persiste, comunícate con el Soporte con tu nombre de usuario y los detalles del juego."
    },

  ]
  return (
    <div>
      <Topheader colorbox="newfaq_header_color" title="Preguntas Frecuentes" />
      <div className="main-container mb-5 mt-4 ">

        <div className={style.btm_safe}>
          <div id="accordion">
            {data.map((item,index)=>{
          return(
            <div key={index} className={`${style.box}`}>
            <div className={`${style.accordionHeader} collapsed`} data-bs-toggle="collapse" href={`#${item.id}`}>
              <div className={style.title_box}>
                <span className={style.title}>{item.ques}</span>
                <svg className={style.arrowIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12.0002 7L8.00051 11L4.00025 7" stroke="#041B67" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>


            <div id={item.id} className='collapse mt-2' data-bs-parent="#accordion">
              <div className={style.desc}>
                {item.ans}
              </div>
            </div>
            </div>
             )
        })}
          </div>
        </div>



      </div>

      <div className={style.btm_fixed_area}>
        <div className={style.btn}>
         <a href='mailto:playerrelations@pokerbaazi.com' target='_blank' rel="noreferrer" style={{color:'white'}}>Escríbenos</a>

        </div>

      </div>
    </div>
  )
}
